import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Text from 'components/shared/Text';
import styles from './styles.module.scss';

function BooleanField(props) {
  return (
    <div className={classnames([styles.booleanFieldWrapper, ...props.wrapperStyles])}>
      <Text
        className={classnames([
          styles.booleanFieldLabel,
          { [styles.booleanFieldWithContentLabel]: props.hasSelection },
          ...props.labelStyles
        ])}
        tag="label">
        {props.name}
      </Text>

      <div id={props.id} className={styles.booleanInputWrapper}>
        <button
          type="button"
          id={props.id}
          value={props.options[0].value}
          className={classnames([
            styles.booleanInput,
            styles.left,
            {
              [styles.active]: props.value === props.options[0].value,
              [styles.blurred]: props.hasSelection && props.value !== props.options[0].value,
              [styles.error]: props.error
            }
          ])}
          onClick={props.onChange}>
          {props.options[0].label}
        </button>
        <button
          type="button"
          id={props.id}
          value={props.options[1].value}
          className={classnames([
            styles.booleanInput,
            styles.right,
            {
              [styles.active]: props.value === props.options[1].value,
              [styles.blurred]: props.hasSelection && props.value !== props.options[1].value,
              [styles.error]: props.error
            }
          ])}
          onClick={props.onChange}>
          {props.options[1].label}
        </button>
      </div>

      {props.error && (
        <Text tag="p" styles={[styles.booleanFieldError]}>
          {props.error}
        </Text>
      )}
    </div>
  );
}

BooleanField.propTypes = {
  error: PropTypes.string,
  hasSelection: PropTypes.bool,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  wrapperStyles: PropTypes.array,
  labelStyles: PropTypes.array
};

BooleanField.defaultProps = {
  error: undefined,
  hasSelection: false,
  value: null,
  wrapperStyles: [],
  labelStyles: []
};

export default BooleanField;
